import * as api from '../api/ptdProcess';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const SET_BACK_TOTALS_PTD = `${prefix}/SET_BACK_TOTALS_PTD`;

export function setBackTotalsPTD({ totalsRunID, ptdRunID, fromSearchType }) {
  return async (dispatch) => {
    dispatch({
      type: SET_BACK_TOTALS_PTD,
      data: {
        totalsRunID,
        ptdRunID,
        fromSearchType,
      },
    });
  };
}

export const PROCESS_EX366 = createRequestTypes(`${prefix}/PROCESS_EX366`);

export const processEx366 = makeApiActionCreatorV3(
  api.processEx366,
  PROCESS_EX366[START],
  PROCESS_EX366[SUCCESS],
  PROCESS_EX366[ERROR],
);

export const FETCH_TAXING_UNITS_BY_FORM = createRequestTypes(
  `${prefix}/FETCH_TAXING_UNITS_BY_FORM`,
);

export const fetchTaxingUnitsByForm = makeApiActionCreatorV3(
  api.fetchTaxingUnitsByForm,
  FETCH_TAXING_UNITS_BY_FORM[START],
  FETCH_TAXING_UNITS_BY_FORM[SUCCESS],
  FETCH_TAXING_UNITS_BY_FORM[ERROR],
);

export const FETCH_EPTS_FORMS = createRequestTypes(
  `${prefix}/FETCH_EPTS_FORMS`,
);

export const fetchEptsForms = makeApiActionCreatorV3(
  api.fetchEptsForms,
  FETCH_EPTS_FORMS[START],
  FETCH_EPTS_FORMS[SUCCESS],
  FETCH_EPTS_FORMS[ERROR],
);

export const FETCH_EPTS_REPORTS = createRequestTypes(
  `${prefix}/FETCH_EPTS_REPORTS`,
);

export const fetchEptsReports = makeApiActionCreatorV3(
  api.fetchEptsReports,
  FETCH_EPTS_REPORTS[START],
  FETCH_EPTS_REPORTS[SUCCESS],
  FETCH_EPTS_REPORTS[ERROR],
);

export const FETCH_PTD_STATE_CODES = createRequestTypes(
  `${prefix}/FETCH_PTD_STATE_CODES`,
);

export const fetchPTDStateCodes = makeApiActionCreatorV3(
  api.fetchPTDStateCodes,
  FETCH_PTD_STATE_CODES[START],
  FETCH_PTD_STATE_CODES[SUCCESS],
  FETCH_PTD_STATE_CODES[ERROR],
);

export const FETCH_PTD_UNMAPPED_STATE_CODES = createRequestTypes(
  `${prefix}/FETCH_PTD_UNMAPPED_STATE_CODES`,
);

export const fetchPTDUnmappedStateCodes = makeApiActionCreatorV3(
  api.fetchPTDUnmappedStateCodes,
  FETCH_PTD_UNMAPPED_STATE_CODES[START],
  FETCH_PTD_UNMAPPED_STATE_CODES[SUCCESS],
  FETCH_PTD_UNMAPPED_STATE_CODES[ERROR],
);

export const FETCH_CLIENT_MAPPINGS = createRequestTypes(
  `${prefix}/FETCH_CLIENT_MAPPINGS`,
);

export const fetchClientMappings = makeApiActionCreatorV3(
  api.fetchClientMappings,
  FETCH_CLIENT_MAPPINGS[START],
  FETCH_CLIENT_MAPPINGS[SUCCESS],
  FETCH_CLIENT_MAPPINGS[ERROR],
);

export const ADD_CLIENT_MAPPING = createRequestTypes(
  `${prefix}/ADD_CLIENT_MAPPING`,
);

export const addClientMapping = makeApiActionCreatorV3(
  api.addClientMapping,
  ADD_CLIENT_MAPPING[START],
  ADD_CLIENT_MAPPING[SUCCESS],
  ADD_CLIENT_MAPPING[ERROR],
);

export const UPDATE_CLIENT_MAPPING = createRequestTypes(
  `${prefix}/UPDATE_CLIENT_MAPPING`,
);

export const updateClientMapping = makeApiActionCreatorV3(
  api.updateClientMapping,
  UPDATE_CLIENT_MAPPING[START],
  UPDATE_CLIENT_MAPPING[SUCCESS],
  UPDATE_CLIENT_MAPPING[ERROR],
);

export const DELETE_CLIENT_MAPPING = createRequestTypes(
  `${prefix}/DELETE_CLIENT_MAPPING`,
);

export const deleteClientMapping = makeApiActionCreatorV3(
  api.deleteClientMapping,
  DELETE_CLIENT_MAPPING[START],
  DELETE_CLIENT_MAPPING[SUCCESS],
  DELETE_CLIENT_MAPPING[ERROR],
);

export const FETCH_PTD_CONFIGURATION = createRequestTypes(
  `${prefix}/FETCH_PTD_CONFIGURATION`,
);

export const fetchPTDConfiguration = makeApiActionCreatorV3(
  api.fetchPTDConfiguration,
  FETCH_PTD_CONFIGURATION[START],
  FETCH_PTD_CONFIGURATION[SUCCESS],
  FETCH_PTD_CONFIGURATION[ERROR],
);

export const UPDATE_PTD_CONFIGURATION = createRequestTypes(
  `${prefix}/UPDATE_PTD_CONFIGURATION`,
);

export const updatePTDConfiguration = makeApiActionCreatorV3(
  api.updatePTDConfiguration,
  UPDATE_PTD_CONFIGURATION[START],
  UPDATE_PTD_CONFIGURATION[SUCCESS],
  UPDATE_PTD_CONFIGURATION[ERROR],
);

export const FETCH_PTD_SU_LAND_TYPES = createRequestTypes(
  `${prefix}/FETCH_PTD_SU_LAND_TYPES`,
);

export const fetchPTDSULandTypes = makeApiActionCreatorV3(
  api.fetchPTDSULandTypes,
  FETCH_PTD_SU_LAND_TYPES[START],
  FETCH_PTD_SU_LAND_TYPES[SUCCESS],
  FETCH_PTD_SU_LAND_TYPES[ERROR],
);

export const IMPORT_PTD_SU_LAND_TYPES = createRequestTypes(
  `${prefix}/IMPORT_PTD_SU_LAND_TYPES`,
);

export const importPTDSULandTypes = makeApiActionCreatorV3(
  api.importPTDSULandTypes,
  IMPORT_PTD_SU_LAND_TYPES[START],
  IMPORT_PTD_SU_LAND_TYPES[SUCCESS],
  IMPORT_PTD_SU_LAND_TYPES[ERROR],
);

export const FETCH_PTD_UNMAPPED_SU_LAND_TYPES = createRequestTypes(
  `${prefix}/FETCH_PTD_UNMAPPED_SU_LAND_TYPES`,
);

export const fetchPTDUnmappedSULandTypes = makeApiActionCreatorV3(
  api.fetchPTDUnmappedSULandTypes,
  FETCH_PTD_UNMAPPED_SU_LAND_TYPES[START],
  FETCH_PTD_UNMAPPED_SU_LAND_TYPES[SUCCESS],
  FETCH_PTD_UNMAPPED_SU_LAND_TYPES[ERROR],
);

export const FETCH_PTD_LAND_TYPES_MAPPINGS = createRequestTypes(
  `${prefix}/FETCH_PTD_LAND_TYPES_MAPPINGS`,
);

export const fetchPTDLandTypeMappings = makeApiActionCreatorV3(
  api.fetchPTDLandTypeMappings,
  FETCH_PTD_LAND_TYPES_MAPPINGS[START],
  FETCH_PTD_LAND_TYPES_MAPPINGS[SUCCESS],
  FETCH_PTD_LAND_TYPES_MAPPINGS[ERROR],
);

export const INSERT_PTD_LAND_TYPES_MAPPING = createRequestTypes(
  `${prefix}/INSERT_PTD_LAND_TYPES_MAPPING`,
);

export const insertPTDLandTypeMapping = makeApiActionCreatorV3(
  api.insertPTDLandTypeMapping,
  INSERT_PTD_LAND_TYPES_MAPPING[START],
  INSERT_PTD_LAND_TYPES_MAPPING[SUCCESS],
  INSERT_PTD_LAND_TYPES_MAPPING[ERROR],
);

export const UPDATE_PTD_LAND_TYPES_MAPPING = createRequestTypes(
  `${prefix}/UPDATE_PTD_LAND_TYPES_MAPPING`,
);

export const updatePTDLandTypeMapping = makeApiActionCreatorV3(
  api.updatePTDLandTypeMapping,
  UPDATE_PTD_LAND_TYPES_MAPPING[START],
  UPDATE_PTD_LAND_TYPES_MAPPING[SUCCESS],
  UPDATE_PTD_LAND_TYPES_MAPPING[ERROR],
);

export const DELETE_PTD_LAND_TYPES_MAPPING = createRequestTypes(
  `${prefix}/DELETE_PTD_LAND_TYPES_MAPPING`,
);

export const deletePTDLandTypeMapping = makeApiActionCreatorV3(
  api.deletePTDLandTypeMapping,
  DELETE_PTD_LAND_TYPES_MAPPING[START],
  DELETE_PTD_LAND_TYPES_MAPPING[SUCCESS],
  DELETE_PTD_LAND_TYPES_MAPPING[ERROR],
);

export const FETCH_PTD_EXEMPTIONS = createRequestTypes(
  `${prefix}/FETCH_PTD_EXEMPTIONS`,
);

export const fetchPTDExemptions = makeApiActionCreatorV3(
  api.fetchPTDExemptions,
  FETCH_PTD_EXEMPTIONS[START],
  FETCH_PTD_EXEMPTIONS[SUCCESS],
  FETCH_PTD_EXEMPTIONS[ERROR],
);

export const IMPORT_PTD_EXEMPTIONS = createRequestTypes(
  `${prefix}/IMPORT_PTD_EXEMPTIONS`,
);

export const importPTDExemptions = makeApiActionCreatorV3(
  api.importPTDExemptions,
  IMPORT_PTD_EXEMPTIONS[START],
  IMPORT_PTD_EXEMPTIONS[SUCCESS],
  IMPORT_PTD_EXEMPTIONS[ERROR],
);

export const FETCH_PTD_UNMAPPED_EXEMPTIONS = createRequestTypes(
  `${prefix}/FETCH_PTD_UNMAPPED_EXEMPTIONS`,
);

export const fetchPTDUnmappedExemptions = makeApiActionCreatorV3(
  api.fetchPTDUnmappedExemptions,
  FETCH_PTD_UNMAPPED_EXEMPTIONS[START],
  FETCH_PTD_UNMAPPED_EXEMPTIONS[SUCCESS],
  FETCH_PTD_UNMAPPED_EXEMPTIONS[ERROR],
);

export const FETCH_PTD_EXEMPTIONS_MAPPINGS = createRequestTypes(
  `${prefix}/FETCH_PTD_EXEMPTIONS_MAPPINGS`,
);

export const fetchPTDExemptionMappings = makeApiActionCreatorV3(
  api.fetchPTDExemptionMappings,
  FETCH_PTD_EXEMPTIONS_MAPPINGS[START],
  FETCH_PTD_EXEMPTIONS_MAPPINGS[SUCCESS],
  FETCH_PTD_EXEMPTIONS_MAPPINGS[ERROR],
);

export const INSERT_PTD_EXEMPTIONS_MAPPING = createRequestTypes(
  `${prefix}/INSERT_PTD_EXEMPTIONS_MAPPING`,
);

export const insertPTDExemptionMapping = makeApiActionCreatorV3(
  api.insertPTDExemptionMapping,
  INSERT_PTD_EXEMPTIONS_MAPPING[START],
  INSERT_PTD_EXEMPTIONS_MAPPING[SUCCESS],
  INSERT_PTD_EXEMPTIONS_MAPPING[ERROR],
);

export const UPDATE_PTD_EXEMPTIONS_MAPPING = createRequestTypes(
  `${prefix}/UPDATE_PTD_EXEMPTIONS_MAPPING`,
);

export const updatePTDExemptionMapping = makeApiActionCreatorV3(
  api.updatePTDExemptionMapping,
  UPDATE_PTD_EXEMPTIONS_MAPPING[START],
  UPDATE_PTD_EXEMPTIONS_MAPPING[SUCCESS],
  UPDATE_PTD_EXEMPTIONS_MAPPING[ERROR],
);

export const DELETE_PTD_EXEMPTIONS_MAPPING = createRequestTypes(
  `${prefix}/DELETE_PTD_EXEMPTIONS_MAPPING`,
);

export const deletePTDExemptionMapping = makeApiActionCreatorV3(
  api.deletePTDExemptionMapping,
  DELETE_PTD_EXEMPTIONS_MAPPING[START],
  DELETE_PTD_EXEMPTIONS_MAPPING[SUCCESS],
  DELETE_PTD_EXEMPTIONS_MAPPING[ERROR],
);

export const FETCH_PVS_TAX_RATE_SUBMISSIONS = createRequestTypes(
  `${prefix}/FETCH_PVS_TAX_RATE_SUBMISSIONS`,
);

export const fetchPVSTaxRateSubmissions = makeApiActionCreatorV3(
  api.fetchPVSTaxRateSubmissions,
  FETCH_PVS_TAX_RATE_SUBMISSIONS[START],
  FETCH_PVS_TAX_RATE_SUBMISSIONS[SUCCESS],
  FETCH_PVS_TAX_RATE_SUBMISSIONS[ERROR],
);

export const CREATE_PVS_TAX_RATE_SUBMISSION = createRequestTypes(
  `${prefix}/CREATE_PVS_TAX_RATE_SUBMISSION`,
);

export const createPVSTaxRateSubmission = makeApiActionCreatorV3(
  api.createPVSTaxRateSubmission,
  CREATE_PVS_TAX_RATE_SUBMISSION[START],
  CREATE_PVS_TAX_RATE_SUBMISSION[SUCCESS],
  CREATE_PVS_TAX_RATE_SUBMISSION[ERROR],
);

export const GET_EXPORT_RUN_TAXING_UNITS = createRequestTypes(
  `${prefix}/GET_EXPORT_RUN_TAXING_UNITS`,
);

export const getExportRunTaxingUnits = makeApiActionCreatorV3(
  api.getExportRunTaxingUnits,
  GET_EXPORT_RUN_TAXING_UNITS[START],
  GET_EXPORT_RUN_TAXING_UNITS[SUCCESS],
  GET_EXPORT_RUN_TAXING_UNITS[ERROR],
);

export const LAUNCH_EXPORT_RUN = createRequestTypes(
  `${prefix}/LAUNCH_EXPORT_RUN`,
);

export const launchExportRun = makeApiActionCreatorV3(
  api.launchExportRun,
  LAUNCH_EXPORT_RUN[START],
  LAUNCH_EXPORT_RUN[SUCCESS],
  LAUNCH_EXPORT_RUN[ERROR],
);

export const GET_EXPORT_RUN_HISTORY = createRequestTypes(
  `${prefix}/GET_EXPORT_RUN_HISTORY`,
);

export const getExportRunHistory = makeApiActionCreatorV3(
  api.getExportRunHistory,
  GET_EXPORT_RUN_HISTORY[START],
  GET_EXPORT_RUN_HISTORY[SUCCESS],
  GET_EXPORT_RUN_HISTORY[ERROR],
);
